/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The method used for collecting payments for the subscription.
 */
export const SubscriptionCollectionMethod = {
  ChargeAutomatically: "charge_automatically",
} as const;
/**
 * The method used for collecting payments for the subscription.
 */
export type SubscriptionCollectionMethod = ClosedEnum<
  typeof SubscriptionCollectionMethod
>;

/** @internal */
export const SubscriptionCollectionMethod$inboundSchema: z.ZodNativeEnum<
  typeof SubscriptionCollectionMethod
> = z.nativeEnum(SubscriptionCollectionMethod);
/** @internal */
export const SubscriptionCollectionMethod$outboundSchema: z.ZodNativeEnum<
  typeof SubscriptionCollectionMethod
> = SubscriptionCollectionMethod$inboundSchema;
